import { topicsData } from "@/mocks/homeData";

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">热门话题</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">大家都在讨论的影视话题，加入聊聊吧</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.name}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#carousel")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-hashtag text-foreground-600 group-hover:text-primary-500 transition-colors text-sm"></i>
              </span>
              <span className="text-foreground-300 text-sm whitespace-nowrap">{topic.name}</span>
              <span className="text-foreground-600 text-xs pl-1 border-l border-background-300 ml-1">{topic.heat}</span>
              <span className="px-1.5 py-0.5 bg-accent-500/20 text-accent-400 text-xs rounded whitespace-nowrap">{topic.tag}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}